import { useMedia } from "react-use";

export function useMediaXs() {
  return useMedia("(max-width: 575.98px)");
}

export function useMediaTablet() {
  return useMedia("(max-width: 770px)");
}

// default large is 1200px, but most popular is 1366px
export function useMediaLarge() {
  return useMedia("(min-width: 1300px)");
}
